module.exports = __webpack_public_path__ + "img/1.272ff10f.jpg";